import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const NAV_ITEMS = [
  { to: '/home',     icon: '🏠', label: 'Home' },
  { to: '/projects', icon: '🏗️', label: 'Projects' },
  { to: '/jira',     icon: '🔗', label: 'JIRA Integration' },
  { to: '/settings', icon: '⚙️', label: 'Settings' },
  { to: '/teams',    icon: '👥', label: 'Teams' },
];

export default function GlobalSidebar() {
  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h5>ZipQA</h5>
        <span style={{ fontSize: 11, color: '#64748b', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '.5px' }}>
          Workspace
        </span>
      </div>
      <nav className="sidebar-menu">
        {NAV_ITEMS.map(({ to, icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `sidebar-item${isActive ? ' active' : ''}`
            }
            style={({ isActive }) =>
              isActive
                ? { background: 'rgba(99,102,241,.15)', color: '#a5b4fc', borderLeft: '3px solid #6366f1' }
                : { borderLeft: '3px solid transparent' }
            }
          >
            <span style={{ marginRight: 10, fontSize: 15 }}>{icon}</span>
            {label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
